import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/list-bullet-fill.svg'


const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "truncate inline-block space-x-1 text-sm w-full" }
const _hoisted_3 = ["onClick"]

import { // api
		getSceneVariationRolesByRecordId
	} from '../../../../queries'

	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	// vue
	import {
		computed, 
		ref,
		onMounted
	} from 'vue'

	
	const __default__ = { name: 'SceneVarRoles' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		showDetails:{
			type: Function,
			default: () => {return}
		},
		variation: {
			type: Object,
			default: () => {return {}}
		} 
	},
  setup(__props) {

	const props = __props

	const userStore = _userStore()
	const _localesStore = localesStore()

	const {t} = useI18n()

	const musicianRoles = ref()
	const standardRoles = ref()
	const loading = ref(true)
	const isStaff = ref(userStore.getContactType === 'Staff')

	onMounted(async () => {
		try {
			loading.value = true

			const recordId = props.variation.recordId
			const contactId = userStore.user.contactId
			const jobId = props.variation['JOBS_SCENES::_kf_jobs_id']
			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
				contactId: contactId,
				jobId: jobId
			})

			const params = `?script.prerequest=${encodeURI("Set Language")}&script.prerequest.param=${encodeURI(scriptParams)}`
			// fetch job by record id
			let res = await getSceneVariationRolesByRecordId(recordId, params)
			const record = res.response.data[0]
			
			musicianRoles.value = userStore.getContactType == 'Staff' ? record.portalData.musician_roles_staff : record.portalData.jobs_variations__JOBS_VARIATIONS_ROLES__jobsVariationsInstrumentalID
			standardRoles.value = userStore.getContactType == 'Staff' ? record.portalData.standard_roles_staff : record.portalData.jobs_variations__JOBS_VARIATIONS_ROLES__jobsVariationsStandardID		
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}
	})

	const groupedData = computed(() => {
		let headings = []

		if(standardRoles?.value?.length) {
			headings.push(
				{subheading: 'Standard Roles'},
				...standardRoles.value
			)
		}

		if(musicianRoles?.value?.length) {
			headings.push(
				{subheading: 'Musician Roles'},
				...musicianRoles.value
			)
		}
		
		return headings
	})

	function hasInstructions(row: any) {
		return row?.['jobs_variations__jobs_variations_roles__INSTRUCTIONS_JOIN_JOBS_jobsVariationsRoleID_instrumental::_kp_instructions_join_jobs_id'] || 
			row?.['jobs_variations__jobs_variations_roles__INSTRUCTIONS_JOIN_JOBS_jobsVariationsRoleID_standard::_kp_instructions_join_jobs_id'] 
	}


return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showDetails(null, 'sceneDetails', 2, null))),
        class: "flex justify-start items-center cursor-pointer"
      }, [
        _createVNode(_component_ArrowLeftIcon, { class: "w-5 h-5" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.returnToVariations")), 1)
        ])
      ])
    ]),
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noRoles'),
      data: groupedData.value,
      loading: loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('102')
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row['jobs_variations__jobs_variations_roles_musician__ROLES__roleID::name_display'] ||
					row['jobs_variations__jobs_variations_roles_standard__ROLES__roleID::name_display']), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        (isStaff.value)
          ? (_openBlock(), _createBlock(_component_tw_table_column, {
              key: 0,
              "class-name": "w-6",
              "header-class-name": "w-6",
              "align-text": "right"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", {
                  class: "h-5 w-5 cursor-pointer",
                  onClick: ($event: any) => (__props.showDetails(row, 'varRolesInstructionsList', null, __props.variation))
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass([ hasInstructions(row) ? 'linked-icon' : 'grayed-icon']),
                    src: _imports_0,
                    alt: "list icon"
                  }, null, 2)
                ], 8, _hoisted_3)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"])
  ], 64))
}
}

})